import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as CopyIcon} from '../../../assets/img/copyIcon.svg';
import Textbox from '../../Common/Textbox'
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import {selectProfileUrl} from "../../../store/selectors/Profile";
import {ReactComponent as BrokeIcon } from '../../../assets/img/broke.svg'
import Toast from "../../Common/Toast";
import ToastMessage from "../../Common/ToastMessage";
import {  getSelfProfileInfo } from "../../../store/entities/Profile/Profile.actions";

const PaymentControlBar = () => {
  const dispatch = useDispatch();
  const userProfileUrl = useSelector(selectProfileUrl)
  console.log('userProfileUrl',userProfileUrl)

  const handleClick = () => {
    var copyText = document.getElementById("profle-url");
    copyText.focus()
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    navigator.clipboard.writeText("https://"+copyText.value);
    Toast(ToastMessage(8), "success")
  }
 
  useEffect(async ()=>{
   await dispatch(getSelfProfileInfo(()=>{

    }))
  },[])
  return (
    <div className={"paymentEmpty"}>
            <BrokeIcon className="broke-logo" />
            <h2 className="BODY_LARGE">
                 Looks like you haven’t received any payments yet. Share your profile with your students to start receiving payment.
            </h2>
            <div className="previewUrlContainer">


            <div className={"publicUrlContainer"}>
             <div className={"inputGroup"}>
               <Textbox tName="publicUrl" loading={true} handleClick={handleClick} htmlFor="profle-url" type="text"
                  additionClass={"inputUrl BODY_MEDIUM"}  value={`teachon.org/${userProfileUrl}`}

                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle copy visibility"

                        edge="end"
                      >
                      <CopyIcon fontSize={22} />
                      </IconButton>
                    </InputAdornment>
                  } />

              </div>
          </div>
          </div>
    </div>
  );
}

export default PaymentControlBar;
